export default "__VITE_PUBLIC_ASSET__308974fe__"